<template>
  <div>
    <div class="row row-cards">
      <div class="col-12 show-order-header">
        <p class="text-right">
          <strong>{{ $t("Status do pedido") }}:</strong>
          <b-badge variant="info">
            <small>{{ order.status }}</small>
          </b-badge>
          <br />
          <small>
            <strong>{{ $t("Data da compra") }}:</strong>
            {{ order.created }}
          </small>
        </p>

        <p class="text-right">
          <b-button @click="back" variant="primary" class="go-back">
            <i class="fa fa-arrow-left"></i>
            {{ $t("Voltar") }}
          </b-button>
          <b-button @click="save" variant="success" ref="sv_order">
            <i class="fa fa-check"></i>
            {{ $t("Salvar alterações") }}
          </b-button>
          <b-dropdown right ref="actionButton">
            <i class="fa fa-gear" slot="button-content"></i>
            <b-dropdown-item @click="generatePDF">
              <i class="fa fa-file fa-fw"></i>
              {{ $t("Exportar PDF") }}
            </b-dropdown-item>

            <b-dropdown-divider></b-dropdown-divider>

            <b-dropdown-header>{{ $t("Status") }}</b-dropdown-header>

            <!-- Pendentes de separação -->
            <b-dropdown-item
              @click="processing_picking"
              v-if="notaFiscal == true && order.status == 'Aprovado'"
            >
              <i class="fas fa-dolly"></i>
              {{ $t("Imprimir Lista de Picking") }}
            </b-dropdown-item>

            <!-- Em separação -->
            <b-dropdown-item
              @click="sigep(true)"
              v-if="
                notaFiscal == true && order.sub_status == 'processing_picking'
              "
            >
              <i class="fas fa-dolly"></i>
              {{ $t("Enviar por SIGEP WEB") }}
            </b-dropdown-item>

            <b-dropdown-item
              @click="changeStatus('picking', 'pending_invoice', true)"
              v-if="
                notaFiscal == true && order.sub_status == 'processing_picking'
              "
            >
              <i class="fas fa-dolly"></i>
              {{ $t("Marcar como Separado") }}
            </b-dropdown-item>

            <!-- Separados -->
            <b-dropdown-item
              @click="changeStatus('waiting_invoice', 'waiting_invoice', true)"
              v-if="notaFiscal == true && order.sub_status == 'pending_invoice'"
            >
              <i class="fas fa-cubes"></i>
              {{ $t("Gerar nota fiscal") }}
            </b-dropdown-item>

            <!-- invoiced  waiting_expedition Pronto para embalar -->
            <b-dropdown-item
              @click="print_all(order)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Imprimir tudo") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="print('has_invoice_doc', '1', order.shipments, order.id)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Imprimir notas fiscais") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="print('has_gnre_doc', '1', order.shipments, order.id)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Imprimir GNRE") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="print('has_label', '1', order.shipments, order.id)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Imprimir etiquetas") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="changeStatus('invoiced', 'processing_expedition', true)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Marcar como embalado") }}
            </b-dropdown-item>

            <!-- Aguardando retirada -->
            <b-dropdown-item
              @click="changeStatus('shipping_informed', 'dispatched', true)"
              v-if="
                notaFiscal == true &&
                order.sub_status == 'processing_expedition'
              "
            >
              <i data-v-256d0edf class="fas fa-dolly-flatbed"></i>
              {{ $t("Marcar como enviado") }}
            </b-dropdown-item>

            <!--<b-dropdown-item
              @click="changeStatus('approved', null, true)"
              :disabled="order.status === 'Aprovado'"
            >
              <i class="fa fa-check fa-fw"></i>
              {{ $t("Marcar como aprovado") }} ({{ $t("Pagamento realizado") }})
            </b-dropdown-item>-->

            <b-dropdown-item
              @click="changeStatus('delivered', null, true)"
              :disabled="order.status === 'Entrega informada'"
            >
              <i class="fa fa-truck fa-fw"></i>
              {{ $t("Marcar como entregue") }} ({{ $t("status final") }})
            </b-dropdown-item>
            <b-dropdown-item
              @click="changeStatus('canceled', null, true)"
              :disabled="order.status === 'Cancelado'"
            >
              <i class="fa fa-ban fa-fw"></i>
              {{ $t("Marcar como cancelado") }} ({{ $t("status final") }})
            </b-dropdown-item>
          </b-dropdown>
        </p>

        <steps-status
          :currentStatus="order.original_status"
          :id="order.id"
        ></steps-status>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ $t("Dados Faturamento") }}</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6">
                <div class="input-group">
                  <label for="name">{{ $t("Nome") }}:</label>
                  <input class="form-control" v-model="orderClone.payer_name" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <label for="lastname">{{ $t("Sobrenome") }}:</label>
                  <input
                    class="form-control"
                    v-model="orderClone.payer_lastname"
                  />
                </div>
              </div>
            </div>

            <div class="row my-4"></div>

            <div class="form-group">
              <div class="form-group">
                <label for="payer_address">{{ $t("Endereço") }}:</label>
                <b-form-input v-model="orderClone.payer_address"></b-form-input>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="input-group">
                  <label for="payer_address_number">{{ $t("Nº") }}:</label>
                  <input
                    class="form-control"
                    v-model="orderClone.payer_address_number"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <label for="payer_address_complement"
                    >{{ $t("Complemento") }}:</label
                  >
                  <input
                    class="form-control"
                    v-model="orderClone.payer_address_complement"
                  />
                </div>
              </div>

              <div class="col-lg-6">
                <div class="input-group">
                  <label for="payer_neighborhood">{{ $t("Bairro") }}:</label>
                  <input
                    class="form-control"
                    v-model="orderClone.payer_neighborhood"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <label for="payer_city">{{ $t("Cidade") }}:</label>
                  <input class="form-control" v-model="orderClone.payer_city" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <label for="payer_state">{{ $t("Estado") }}:</label>
                  <input
                    class="form-control"
                    v-model="orderClone.payer_state"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="input-group">
                  <label for="payer_country">{{ $t("País") }}:</label>
                  <input
                    class="form-control"
                    v-model="orderClone.payer_country"
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="payer_zipcode">{{ $t("CEP") }}:</label>
              <b-form-input
                v-model="orderClone.payer_zipcode"
                v-mask="'#####-###'"
              ></b-form-input>
            </div>

            <div class="row my-4"></div>

            <div class="form-group">
              <label for="payer_email">Email:</label>
              <b-form-input
                v-model="orderClone.payer_email"
                type="email"
              ></b-form-input>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-3">
                  <div class="form-group">
                    <label for="telefone">{{ $t("DDD") }}:</label>
                    <b-form-input
                      v-model="orderClone.payer_phone_area"
                      v-mask="['##']"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-9">
                  <div class="form-group">
                    <label for="telefone">{{ $t("Telefone") }}:</label>
                    <b-form-input
                      v-model="orderClone.payer_phone"
                      v-mask="['####-####', '#####-####']"
                    ></b-form-input>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <label for="telefone">{{ $t("DDD 2") }}:</label>
                    <b-form-input
                      v-model="orderClone.payer_phone2_area"
                      v-mask="['##']"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-9">
                  <div class="form-group">
                    <label for="telefone">{{ $t("Telefone 2") }}:</label>
                    <b-form-input
                      v-model="orderClone.payer_phone2"
                      v-mask="['####-####', '#####-####']"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-4"></div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6">
                  <div class="input-group">
                    <label for="cpf">{{ $t("CPF") }}:</label>
                    <input
                      class="form-control"
                      v-model="orderClone.payer_cpf"
                      v-mask="'###.###.###-##'"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="input-group">
                    <label for="cnpj">{{ $t("CNPJ") }}:</label>
                    <input
                      class="form-control"
                      v-model="orderClone.payer_cnpj"
                      v-mask="'XX.XXX.XXX/XXXX-XX'"
                    />
                  </div>
                </div>

                <div class="col-12 col-lg-6" v-if="orderClone.payer_cnpj">
                  <div class="input-group">
                    <label for="razao_social">{{ $t("Razão Social") }}:</label>
                    <input
                      id="razao_social"
                      class="form-control"
                       v-if="orderClone.payer_razao_social"
                      v-model="orderClone.payer_company_name"
                    />
                    <input
                      id="razao_social"
                      class="form-control"
                      v-else
                      v-model="orderClone.payer_company_name"
                    />
                  </div>
                </div>

                <div class="col-12 col-lg-6" v-if="orderClone.payer_cnpj">
                  <div class="input-group">
                    <label for="payer_ie"
                      >{{ $t("Inscrição Estadual") }}:</label
                    >
                    <input
                      id="payer_id"
                      class="form-control"
                      v-model="orderClone.payer_ie"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-4"></div>

            <div class="form-group">
              <label for="payer_additional_info"
                >{{ $t("Informações Adicionais") }}:</label
              >
              <b-form-input
                v-model="orderClone.payer_additional_info"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ $t("Dados Entrega") }}</h3>
            <div class="card-options">
              <b-button
                size="sm"
                class="ml-2"
                :variant="!showAddressShipping ? 'primary' : 'secondary'"
                @click="showAddressShipping = !showAddressShipping"
              >
                {{
                  !showAddressShipping
                    ? $t("Ver Dados de Entrega")
                    : $t("Ver Endereço")
                }}
              </b-button>
            </div>
          </div>
          <div class="card-body">
            <div v-if="showAddressShipping">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="form-group">
                    <label for="receiver_name">{{ $t("Nome") }}:</label>
                    <b-form-input
                      v-model="orderClone.receiver_name"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="form-group">
                    <label for="receiver_lastname"
                      >{{ $t("Sobrenome") }}:</label
                    >
                    <b-form-input
                      v-model="orderClone.receiver_lastname"
                    ></b-form-input>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="receiver_address">{{ $t("Endereço") }}:</label>
                <b-form-input
                  v-model="orderClone.receiver_address"
                ></b-form-input>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="input-group">
                    <label for="receiver_address_number">{{ $t("Nº") }}:</label>
                    <b-form-input
                      v-model="orderClone.receiver_address_number"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="input-group">
                    <label for="receiver_address_complement"
                      >{{ $t("Complemento") }}:</label
                    >
                    <b-form-input
                      v-model="orderClone.receiver_address_complement"
                    ></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="input-group">
                    <label for="receiver_neighborhood"
                      >{{ $t("Bairro") }}:</label
                    >
                    <b-form-input
                      v-model="orderClone.receiver_neighborhood"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="input-group">
                    <label for="receiver_city">{{ $t("Cidade") }}:</label>
                    <b-form-input
                      v-model="orderClone.receiver_city"
                    ></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="input-group">
                    <label for="payer_state">{{ $t("Estado") }}:</label>
                    <b-form-input
                      v-model="orderClone.receiver_state"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="input-group">
                    <label for="receiver_country">{{ $t("País") }}:</label>
                    <b-form-input
                      v-model="orderClone.receiver_country"
                    ></b-form-input>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="receiver_zipcode">{{ $t("CEP") }}:</label>
                <b-form-input
                  v-model="orderClone.receiver_zipcode"
                  v-mask="'#####-###'"
                ></b-form-input>
              </div>
            </div>

            <div v-if="!showAddressShipping">
              <div class="form-group">
                <label for="receiver_email">Email:</label>
                <b-form-input
                  v-model="orderClone.receiver_email"
                  type="email"
                ></b-form-input>
              </div>

              <div class="row">
                <div class="col-3">
                  <div class="form-group">
                    <label for="telefone">{{ $t("DDD") }}:</label>
                    <b-form-input
                      v-model="orderClone.receiver_phone_area"
                      v-mask="['##']"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-9">
                  <div class="form-group">
                    <label for="telefone">{{ $t("Telefone") }}:</label>
                    <b-form-input
                      v-model="orderClone.receiver_phone"
                      v-mask="['####-####', '#####-####']"
                    ></b-form-input>
                  </div>
                </div>
              </div>

              <hr class="dropdown-divider" />

              <!-- impressão -->
              <div class="card" v-if="order.shipments.length > 0">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <div class="text-center" style="width: 100%">
                    {{ $t("Impressão") }}
                  </div>
                </b-card-header>
                <b-card-body>
                  <div v-if="notaFiscal == true">
                    <label>{{ $t("Impressão") }}</label>
                  </div>
                  <div v-if="notaFiscal == true" class="form-group is-flex-1">
                    <div
                      style="
                        text-align: left;
                        float: left;
                        padding-bottom: 10px;
                      "
                      v-for="(key, tag) in filteredTags"
                      v-bind:key="tag"
                    >
                      <a
                        @click="print(tag, key, order.shipments, order.id)"
                        v-html="get_print_html(tag, key)"
                        style="cursor: pointer"
                      ></a>
                    </div>
                  </div>
                  <div v-else>
                    <div style="text-align: left; float: left">
                      <a
                        @click="
                          print(
                            'has_label',
                            order.tags.has_label,
                            order.shipments,
                            order.id
                          )
                        "
                        v-html="
                          get_print_html('has_label', order.tags.has_label)
                        "
                        style="cursor: pointer"
                      ></a>
                    </div>
                  </div>
                </b-card-body>
              </div>

              <order-shipments
                :shipment="shipment"
                v-for="(shipment, index) in order.shipments"
                v-bind:key="shipment.id"
                :shipmentkey="shipment.id"
                :shipmentIndex="index"
                :status="order.status"
                :hasPermissionToEdit="hasPermissionToEdit"
              ></order-shipments>

              <p
                class="text-right"
                v-if="
                  order.status != 'Entregue' && order.status != 'Em Transito'
                "
              >
                <b-button variant="success" @click="addNewShipping">
                  <i class="fa fa-plus"></i>
                  {{ $t("Criar nova entrega") }}
                </b-button>
              </p>
            </div>
          </div>
        </div>
      </div>

      <b-col sm="12">
        <b-card header="Itens do pedido" header-tag="header" no-body>
          <!--<b-table striped hover :items="order.items" :fields="fields"></b-table>-->
          <table class="table b-table table-striped table-hover">
            <thead class>
              <tr>
                <th>{{ $t("SKU") }}</th>
                <th>{{ $t("Nome") }}</th>
                <th>{{ $t("Preço") }}</th>
                <th>{{ $t("Quantidade") }}</th>
                <th>{{ $t("Desconto") }}</th>
                <th>{{ $t("Comissão") }}</th>
                <th>{{ $t("Imposto") }}</th>
                <th>{{ $t("Total") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in order.items" v-bind:key="item.id">
                <td>
                  <span>{{ item.sku }}</span>
                  <span v-if="item.original_sku">
                    <small>({{ item.original_sku }})</small>
                  </span>
                  <span v-if="item.variation.sku"
                    >&nbsp;- {{ item.variation.sku }}</span
                  >
                </td>
                <td>{{ item.name }}</td>
                <td>{{ formatCurrency(item.price, locale) }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ formatCurrency(item.discount, locale) }}</td>
                <td>
                  {{ formatCurrency(item.commission.total_charged, locale) }}
                  <b-badge pill variant="success"
                    >{{ item.commission.tax }}%</b-badge
                  >
                </td>
                <td>{{ formatCurrency(item.tax ? item.tax : 0, locale) }}</td>
                <td>{{ formatCurrency(item.total, locale) }}</td>
              </tr>
            </tbody>
          </table>

          <b-button
            v-if="order.items.length <= 0"
            slot="footer"
            size="sm"
            variant="success"
            v-b-modal.modalPrevent
            >{{ $t("Adicionar novo") }}</b-button
          >
        </b-card>
      </b-col>

      <div class="col-md-4 col-sm-6">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ $t("Dados Adicionais") }}</h3>
          </div>
          <div class="card-body">
            <div v-if="orderClone.delivery_type">
              <b>{{ $t("Tipo de Entrega") }}:</b>
              {{ orderClone.delivery_type }}
            </div>

            <div v-if="orderClone.shipments.length > 0">
              <b>{{ $t("Data estimada de entrega") }}:</b>
              {{
                formatDateDelivery(
                  orderClone.shipments[0].estimate_delivery_date,
                  locale
                )
              }}
            </div>

            <div v-if="orderClone.expected_delivery_date">
              <b>{{ $t("Data estimada de envio") }}:</b>
              {{
                formatDateDelivery(orderClone.expected_delivery_date, locale)
              }}
            </div>

            <div v-if="orderClone.expected_send_date">
              <b>{{ $t("Data limite para envio") }}:</b>
              {{ formatDateDelivery(orderClone.expected_send_date, locale) }}
            </div>

            <div class="mt-3">
              <b>{{ $t("Plugg ID") }}:</b>
              {{ orderClone.id }}
            </div>

            <div
              v-for="availableIn in orderClone.available"
              v-bind:key="availableIn"
              class="mt-3"
            >
              {{ availableIn }}
            </div>

            <div v-if="orderClone.external" class="mt-3">
              <b>IDs Externos</b>
              <br />
              <div
                v-for="(value, key) in orderClone.external"
                v-bind:key="value"
              >
                <b>{{ getAppNameByClientID(key) }}</b
                >: {{ value }}
              </div>
            </div>

            <div
              v-if="orderClone.commission.total_charged != null"
              class="mt-3"
            >
              <b>Comissões</b>
              <br />
              {{ orderClone.commission.total_charged }}
              <b-badge pill variant="success"
                >{{ orderClone.commission.tax }}%</b-badge
              >
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-6">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ $t("Dados de pagamento") }}</h3>
          </div>
          <div class="card-body log_history">
            <div v-if="orderClone.payments.length > 0">
              <b-list-group
                v-for="payment in orderClone.payments"
                :key="payment._id"
              >
                <b-list-group-item>
                  <span class="message">
                    <b>{{ $t("Total") }}:</b>
                    {{ formatCurrency(payment.payment_total, locale) }}
                  </span>
                  <span class="message" v-if="payment.payment_interest">
                    <b>{{ $t("Total de Juros") }}:</b>
                    {{ formatCurrency(payment.payment_interest, locale) }}
                  </span>
                  <span class="message">
                    <b>{{ $t("Método") }}:</b>
                    {{ capitalizeFirstLetter(payment.payment_method) }}
                  </span>
                  <span class="message">
                    <b>{{ $t("Tipo") }}:</b>
                    {{ capitalizeFirstLetter(payment.payment_type) }}
                  </span>
                  <span class="message" v-if="payment.payment_installments">
                    <b>{{ $t("Número de parcelas") }}:</b>
                    {{ payment.payment_installments }}
                  </span>
                </b-list-group-item>
              </b-list-group>
            </div>
            <p v-else>
              {{ $t("Não recebemos os dados de pagamento deste pedido.") }}.
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-6">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ $t("Totais") }}</h3>
          </div>

          <div class="card-body">
            <div class="input-group">
              <label for="subtotal">{{ $t("Subtotal") }}:</label>
              <b-form-input
                id="subtotal"
                v-money="money"
                v-model="orderClone.subtotal"
              ></b-form-input>
            </div>
            <div class="input-group">
              <label for="shipping">{{ $t("Frete") }}:</label>
              <b-form-input
                id="shipping"
                v-money="money"
                v-model="orderClone.shipping"
              ></b-form-input>
            </div>
            <div class="input-group">
              <label for="discount">{{ $t("Desconto") }}:</label>
              <b-form-input
                id="discount"
                v-money="money"
                v-model="orderClone.discount"
              ></b-form-input>
            </div>
            <div class="input-group">
              <label for="tax">{{ $t("Imposto") }}:</label>
              <b-form-input
                id="tax"
                v-money="money"
                v-model="orderClone.tax"
              ></b-form-input>
            </div>
            <div class="input-group">
              <label for="total"
                >{{ $t("Total") }}:
                <a
                  v-b-tooltip.hover
                  title="O valor Total corresponde ao Subtotal dos Itens + Frete - Desconto"
                >
                  <i class="dropdown-icon fe fe-help-circle ml-0"></i>
                </a>
              </label>
              <b-form-input
                id="total"
                v-money="money"
                v-model="orderClone.total"
              ></b-form-input>
            </div>
            <div class="input-group">
              <label for="total_paid">
                {{ $t("Total Pago") }}:
                <a
                  v-b-tooltip.hover
                  title="O valor Total Pago corresponde ao Total + Juros de Parcelamento"
                >
                  <i class="dropdown-icon fe fe-help-circle ml-0"></i>
                </a>
              </label>
              <b-form-input
                id="total_paid"
                v-money="money"
                v-model="orderClone.total_paid"
              ></b-form-input>
            </div>

            <div class="input-group" v-if="orderClone.discount_description">
              {{ orderClone.discount_description }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ $t("Histórico de Status") }}</h3>
          </div>
          <div class="card-body log_history">
            <div v-if="orderClone.status_history.length > 0">
              <b-list-group
                v-for="status_history in orderClone.status_history"
                :key="status_history._id"
              >
                <b-list-group-item>
                  <span class="date">{{
                    formatDate(status_history.date, locale)
                  }}</span>
                  <span class="message">{{ $t(status_history.status) }}</span>
                  <span class="app">
                    {{ $t("Aplicação que realizou esta ação") + ":" }}
                    <b>{{
                      getAppNameByClientID(status_history.user_client_id)
                    }}</b>
                  </span>
                </b-list-group-item>
              </b-list-group>
            </div>
            <p v-else>
              {{
                $t("Não encontramos atualizações de status para este pedido.")
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ $t("Logs do Pedido") }}</h3>
          </div>
          <div class="card-body log_history">
            <div v-if="orderClone.log_history.length > 0">
              <b-list-group
                v-for="log_history in orderClone.log_history"
                :key="log_history._id"
              >
                <b-list-group-item>
                  <span class="date">{{
                    formatDate(log_history.date, locale)
                  }}</span>
                  <span class="message">{{
                    log_history.message ? $t(log_history.message) : ""
                  }}</span>
                  <span class="app">
                    {{ $t("Aplicação que realizou esta ação") + ":" }}
                    <b>{{
                      getAppNameByClientID(log_history.user_client_id)
                    }}</b>
                  </span>
                </b-list-group-item>
              </b-list-group>
            </div>
            <!--            <p v-else>{{ $t('Não encontramos nenhum log nesse pedido.') }}</p>-->
          </div>
        </div>
      </div>

      <div class="col-md-4 col-sm-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ $t("Logs de Usuários") }}</h3>
          </div>
          <div class="card-body log_permanent">
            <div v-if="orderClone.log_permanent.length > 0">
              <b-list-group
                v-for="log_permanent in orderClone.log_permanent"
                :key="log_permanent._id"
              >
                <b-list-group-item>
                  <span class="date">{{
                    formatDate(log_permanent.date, locale)
                  }}</span>
                  <span class="message">{{ log_permanent.message }}</span>
                  <span class="app">
                    {{ $t("Aplicação que realizou esta ação" + ": ") }}
                    <b>{{
                      getAppNameByClientID(log_permanent.user_client_id)
                    }}</b>
                  </span>
                </b-list-group-item>
              </b-list-group>
            </div>
            <p v-else>{{ $t("Não encontramos nenhum log nesse pedido.") }}</p>
          </div>
        </div>
      </div>

      <!--<div class="col-md-6 col-sm-12">
                <pre>{{ orderClone }}</pre>
      </div>-->
    </div>

    <div>
      <!-- Modal add new product -->
      <b-modal
        id="modalPrevent"
        :title="$t('Adicionar novo item ao pedido')"
        centered
        ref="modal"
        @ok="handleOk"
        @show="clearModalNewIten"
      >
        <b-form @submit.stop.prevent="submitNewItem" ref="formNewItem">
          <div class="form-group">
            <b-form-input
              name="product_sku"
              :placeholder="$t('SKU do produto')"
              v-model.trim="newProduct.sku"
              required
            ></b-form-input>
            <b-form-text id="inputFormatterHelp">
              {{ $t("Lembre-se: o") }}
              <strong>SKU</strong>
              {{ $t("deve ser único") }}.
            </b-form-text>
          </div>

          <div class="form-group">
            <b-form-input
              name="product_name"
              :placeholder="$t('Nome')"
              v-model="newProduct.name"
              required
            ></b-form-input>
          </div>

          <div class="form-group">
            <b-form-input
              name="product_price"
              :placeholder="$t('Preço ex: 29.99')"
              v-model="newProduct.price"
              required
            ></b-form-input>
          </div>

          <div class="form-group">
            <b-form-input
              name="product_quantity"
              :placeholder="$t('Quantidade')"
              v-model="newProduct.quantity"
              required
            ></b-form-input>
          </div>
        </b-form>
      </b-modal>
    </div>

    <div class="row row-cards">
      <div class="col-12">
        <p class="text-right">
          <b-button @click="back" variant="primary" class="go-back">
            <i class="fa fa-arrow-left"></i>
            {{ $t("Voltar") }}
          </b-button>
          <b-button @click="save" variant="success">
            <i class="fa fa-check"></i>
            {{ $t("Salvar alterações") }}.
          </b-button>
          <b-dropdown right>
            <i class="fa fa-gear" slot="button-content"></i>
            <b-dropdown-item @click="generatePDF">
              <i class="fa fa-file fa-fw"></i>
              {{ $t("Exportar PDF") }}
            </b-dropdown-item>

            <b-dropdown-divider></b-dropdown-divider>

            <b-dropdown-header>{{ $t("Status") }}</b-dropdown-header>

            <!-- Pendentes de separação -->
            <b-dropdown-item
              @click="processing_picking"
              v-if="notaFiscal == true && order.status == 'Aprovado'"
            >
              <i class="fas fa-dolly"></i>
              {{ $t("Imprimir Lista de Picking") }}
            </b-dropdown-item>

            <!-- Em separação -->
            <b-dropdown-item
              @click="sigep(true)"
              v-if="
                notaFiscal == true && order.sub_status == 'processing_picking'
              "
            >
              <i class="fas fa-dolly"></i>
              {{ $t("Enviar por SIGEP WEB") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="changeStatus('picking', 'pending_invoice', true)"
              v-if="
                notaFiscal == true && order.sub_status == 'processing_picking'
              "
            >
              <i class="fas fa-dolly"></i>
              {{ $t("Marcar como Separado") }}
            </b-dropdown-item>

            <!-- Separados -->
            <b-dropdown-item
              @click="changeStatus('waiting_invoice', 'waiting_invoice', true)"
              v-if="notaFiscal == true && order.sub_status == 'pending_invoice'"
            >
              <i class="fas fa-cubes"></i>
              {{ $t("Gerar nota fiscal") }}
            </b-dropdown-item>

            <!-- invoiced  waiting_expedition Pronto para embalar -->
            <b-dropdown-item
              @click="print_all(order)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Imprimir tudo") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="print('has_invoice_doc', '1', order.shipments, order.id)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Imprimir notas fiscais") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="print('has_gnre_doc', '1', order.shipments, order.id)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Imprimir GNRE") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="print('has_label', '1', order.shipments, order.id)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Imprimir etiquetas") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="changeStatus('invoiced', 'processing_expedition', true)"
              v-if="
                notaFiscal == true && order.sub_status == 'waiting_expedition'
              "
            >
              <i class="fas fa-boxes"></i>
              {{ $t("Marcar como embalado") }}
            </b-dropdown-item>

            <!-- Aguardando retirada -->
            <b-dropdown-item
              @click="changeStatus('shipping_informed', 'dispatched', true)"
              v-if="
                notaFiscal == true &&
                order.sub_status == 'processing_expedition'
              "
            >
              <i data-v-256d0edf class="fas fa-dolly-flatbed"></i>
              {{ $t("Marcar como enviado") }}
            </b-dropdown-item>

            <b-dropdown-item
              @click="changeStatus('delivered', null, true)"
              :disabled="order.status === 'Entrega informada'"
            >
              <i class="fa fa-truck fa-fw"></i>
              {{ $t("Marcar como entregue") }}
            </b-dropdown-item>
            <b-dropdown-item
              @click="changeStatus('canceled', null, true)"
              :disabled="order.status === 'Cancelado'"
            >
              <i class="fa fa-ban fa-fw"></i>
              {{ $t("Marcar como cancelado") }}
            </b-dropdown-item>
          </b-dropdown>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OrderShipments from "./OrderShipments/OrderShipments.vue";
import StepsStatus from "./StepsStatus";
import { diff } from "deep-object-diff";
import axios from "axios";
import { mask } from "vue-the-mask";
import VueNumeric from "vue-numeric";
import moment from "moment";
import { VMoney } from "v-money";
import swal from "sweetalert2";
import { AppService } from "../../services/appService";
import _ from "lodash";
import barramento from "../../barramento";

export default {
  name: "show-order",
  props: ["locale", "scroll", "method", "notaFiscal"],
  directives: { mask, money: VMoney },
  components: { OrderShipments, VueNumeric, StepsStatus },

  beforeMount() {
    const subtotal = this.formatPrice(this.orderClone.subtotal);
    const shipping = this.formatPrice(this.orderClone.shipping);
    const total_paid = this.formatPrice(this.orderClone.total_paid);
    const discount = this.formatPrice(this.orderClone.discount);
    const total = this.formatPrice(this.orderClone.total);

    this.orderClone.subtotal = subtotal;
    this.orderClone.shipping = shipping;
    this.orderClone.total_paid = total_paid;
    this.orderClone.discount = discount;
    this.orderClone.total = total;

    this.formattedFieldsOrderClone.subtotal = subtotal;
    this.formattedFieldsOrderClone.shipping = shipping;
    this.formattedFieldsOrderClone.total_paid = total_paid;
    this.formattedFieldsOrderClone.discount = discount;
    this.formattedFieldsOrderClone.total = total;

    this.orderClone.payer_phone = this.order.payer_phone;
    this.orderClone.payer_phone_area = this.order.payer_phone_area;
    this.orderClone.payer_phone2 = this.order.payer_phone2;
    this.orderClone.payer_phone2_area = this.order.payer_phone2_area;
    this.orderClone.receiver_phone = this.order.receiver_phone;

    if (
      this.orderClone.status_history &&
      this.orderClone.status_history.length
    ) {
      this.orderClone.status_history = this.orderClone.status_history.sort(
        (a, b) => moment(b.date).diff(moment(a.date))
      );
    }

    if (this.orderClone.log_history && this.orderClone.log_history.length) {
      this.orderClone.log_history = this.orderClone.log_history.sort((a, b) =>
        moment(b.date).diff(moment(a.date))
      );
    }

    if (this.orderClone.log_permanent && this.orderClone.log_permanent.length) {
      this.orderClone.log_permanent = this.orderClone.log_permanent.sort(
        (a, b) => moment(b.date).diff(moment(a.date))
      );
    }
  },
  data() {
    return {
      showAddressShipping: true,

      fields: [
        { key: "sku", label: "SKU" },
        { key: "name", label: "Nome" },
        { key: "price", label: "Preço" },
        { key: "quantity", label: "Quantidade" },
        { key: "discount", label: "Desconto" },
        { key: "commission.total_charged", label: "Comissão" },
        { key: "total", label: "Total" },
      ],

      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },

      newProduct: {
        sku: null,
        name: null,
        price: null,
        quantity: null,
        total: 0,
      },

      // se não for clone profundo, então os objetos mais profundos sofrerão mutação
      // ler: https://medium.com/@manjuladube/understanding-deep-and-shallow-copy-in-javascript-13438bad941c
      orderClone: _.cloneDeep(this.$store.state.order.order),
      // precisa do clone abaixo pra poder formatar alguns campos e não dar diff na hora de salvar,
      // por conta da formatação
      formattedFieldsOrderClone: _.cloneDeep(this.$store.state.order.order),

      teste: this.$store.state.showorder,

      exportAlert: {
        show: false,
        path: "",
      },
      localeMap: {
        'pt': 'pt-BR',
        'br': 'pt-BR',
        'es': 'es-ES',
        'US': 'en-US',
        'pt_BR': 'pt-BR'
      },

      appID: {
        a106d72f997e5d3c8a08ce5c32e849b7: "CiaShop - Integração",
        "5de98c314871a4f1970eb387e937db5c": "XtechCommerce",
        "2bce91642941339844cec01e1803abcf": "XML DEV",
        "91dbdde41a4a3393fd4d781dbfe35f4d": "WalMart",
        "5224f670b019ce61b0c8ad8d1d87d9a2": "VtexMkt",
        "417d68fecb9d6f2cfb2cce2e443682e1": "Vtex ERP",
        "7b98c37b915608c664ca5fe3fba26782": "Virtualskateshop",
        "2d1ef640f8e72c38fafd51f47849198e": "UoouCommerce",
        "4c1e304ddf32b203faaff73b71465964": "Tricae",
        "032257a41e63392f239f1e26ec059faf": "TMWxD-Lojamatel",
        "220b16e9718ec487ad8653ba2554f143": "TMWxD-Decora",
        "22cf65484dea17d9c6d198910f13f3b0": "TMWxD",
        "7206d07797468b82d906a443e3245ca1": "Teste TI CCell",
        "9f8502dc364860c4a3b4601690c09b08": "Syncmoze",
        "4fbc841004d54d64c76870c478aafbdb": "Stoom",
        "7fb8a3c327fdefecc4f24df9f0d5a489": "SSPlus",
        "4cfb7397a57dd15e20db8d14424a8a88": "shoppub",
        "64b647388d34d5fb5d8e01a9b411c43e": "Shopfacil",
        "1f57fb5127ee7060993a7b5b8e2ac8a7": "Sabrina",
        "54ee548bbbf04aca3ff627e8637b6e9a": "Ricardo Eletro ",
        "70d54252876996a817b5baa929b8eb74": "Respostas Automáticas",
        "5c3bb167c1d19e8b6cb1f5b67ae75d0a": "Precificação",
        "6e19e8b91aa41d1911cf24ef4ae265e7": "Pedidos",
        "9d510fbf530d324509298323e9029efd": "Outlet do Músico",
        "2aac763e61756161c1252ec8ded8a52d": "OPTE+",
        "33fa51547c27e4d751816b2707d8de76": "OpenCart API",
        "788ceba032b67a0c12767667c09b24d3": "Opeco",
        "4ab7e66d63b4331b89df9366d365d1d5": "Novo Plugin de Teste",
        "6f2682f98ecfdfc852935e37b53c1cde": "Notificações por Email",
        "28e15d02a68d03ffbb0ebf3197fc7a85": "Nota Fiscal eletrônica",
        "1e1f6881d288028104c74aa87910452b": "MyMarketplace",
        "3bc5b02d367af07061257df2316d1707": "Mobly",
        "373bd948d42e6923b97e67d0ce1aa4ad": "Millenium ERP",
        "770b50e49ee1f0899e295e5d672a5479": "MeuAr",
        "81498500a3fea85ca24c3a9a1313f867": "MercadoLivreDev",
        "2d6ce830051c99e5f784afebf8b92414": "Mercado Shops",
        "63af8256cced7335f8d4ede9175a2352":
          "Mercado Livre Perguntas Gerenciador",
        "9b80a0ddd78bd146d289987b8715a8da": "Marketplace Tiago",
        "01b176050c4dbb4eeb347dfa48d1366e": "Marketplace Felipe",
        "7de4f283401c91fee5a86e9f6a56ae98": "Magazine Luiza",
        "32b124b71880fe446b7ea40e9a24f531": "Loja Virtual",
        "9f2c96d28e70e03e23ff0ae35e770db7": "KPL (Ábacos) ERP",
        "14cd0770b0746009ba330b1d2eb23114": "Kanui",
        "8f92e9052fda9ccf3dc6f465f4e52608": "Integração TOTVS",
        "26faaee569b0b2faf74864d4b2c5af42": "Integração Polihouse APP",
        "4309dd5a97406d56ea077eb426abb718": "Integração com a Livelo",
        "860f7a809d8252f0536c6135aab2a4a6": "Gustavo ML",
        "22a8e2f2d09d5801b4f4fd488049c54e": "Frete Rápido",
        "1169c8db2365e89fa8fc25cbff611908": "Frete Planilha",
        "2ffe66723c1431403cbb98a463d8e981": "Frenet",
        "1b4cfd70c334154d816ee83d4fae986a": "Fotter",
        "769ff3cf8bab951e7d6ed7032afebd7e": "ERP Usthemp",
        "5d614723ca4b002723489c67d026be96": "Dafiti Dev",
        "1411557987c12efd8ee1da6bf481fde1": "CorreiosDev",
        "117db8ea06eca0f5af5602e9939ce601": "Correios",
        "27b9889bf97b956e57da4d98da5b1f5e": "CoreV2",
        "64c86d1fe6adf98602994e2bec41bfe5": "Cnova",
        "76b6a6897c736f4047c7099a8a7ff210": "Catálogo",
        "7c0d4545e312d0c732807c7b8ab25fdd": "Carrefour",
        "4211b03272e07aa35f9292f5299a8bf1": "CaptarePRO",
        "048e9f2efcf6659867648b43c2b7a7ca": "C&A",
        "8dffd793fb3474b9d8e96b77d1765a8e": "b2w-local-teste",
        "6bd10e36e53ed4466d477c6b275c397b": "B2W V2",
        "041c45aceeecf5bc1ec173012ceb2dae": "B2W",
        "06fbad3480cf83d439cc271e86eaa82b": "Amazon",
      },

      statusOptions: {
        pending: "Pendente",
        paid: "Pago",
        approved: "Aprovado",
        partial_payment: "Pagamento parcial",
        shipping_informed: "Entrega informada",
        waiting_invoice: "Nota fiscal solicitada",
        invoice_error: "Erro ao gerar nota fiscal",
        shipped: "Em Trânsito",
        shipping_error: "Erro ao enviar entrega",
        delivered: "Recebido",
        canceled: "Cancelado",
        under_review: "Sob análise",
      },
    };
  },

  computed: {
    ...mapGetters({
      user: "getUserObject",
      order: "getOrderObject",
    }),
    hasPermissionToEdit() {
      const subuser = this.user.pluggToSubuser;
      const permissions = subuser ? subuser.permissions : null;

      const has = !(
        subuser &&
        permissions &&
        !permissions.find((x) => x === "core.writeOrders")
      );
      return has;
    },
    filteredTags() {
      const docs = ["has_invoice_doc", "has_gnre_doc", "has_label"];

      const obj = {};

      if (this.order.tags) {
        Object.keys(this.order.tags).forEach((x) => {
          if (docs.find((y) => y === x)) {
            obj[x] = this.order.tags[x];
          }
        });
      }

      return obj;
    },
  },

  methods: {
    ...mapActions({
      addNewItem: "addNewItem",
      updateOrder: "updateOrder",
      showOrderLogs: "showOrderLogs",
      removeCurrentOrder: "removeCurrentOrder",
    }),

    seeAddress(bool) {
      this.showAddressShipping = bool;
    },

    getAppNameByClientID(clientID) {
      return AppService.getNameOfAppByClientID(clientID);
    },

    editPermissionErrorAlert() {
      swal({
        title: "Ops!",
        text: this.$t("Você não possui permissão para editar pedidos."),
        type: "error",
        closeOnConfirm: false,
        closeOnCancel: false,
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: true,
      });
    },

    back() {
      barramento.$emit("orders_status_buttons_export", true);
      this.removeCurrentOrder();
      this.$emit("input", null);
      this.method();
    },

    formatDate(value, loc) {
      if (value) {
        const date = new Date(String(value));

        const locale = this.localeMap[loc] || 'pt-BR';

        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
          timeZone: 'America/Sao_Paulo' // Adjust timezone as needed
        };

        return date.toLocaleString(locale, options);
      }
    },

    formatDateDelivery: function (value, loc) {
      if (value) {
        const date = new Date(String(value));
        const locale = this.localeMap[loc] || 'pt-BR';

        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          timeZone: 'America/Sao_Paulo' // Adjust timezone as needed
        };

        return date.toLocaleDateString(locale, options);
      }
    },

    capitalizeFirstLetter(string) {
      if (string && string.length) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
    },

    formatCurrency(value, loc) {
      if (loc == "US") {
        return Intl.NumberFormat("en-US", {
          currency: "USD",
          style: "currency",
          minimumFractionDigits: 2,
        }).format(value);
      } else if (loc == "AR") {
        return Intl.NumberFormat("es-ar", {
          currency: "ARS",
          style: "currency",
          minimumFractionDigits: 2,
        }).format(value);
      } else {
        return Intl.NumberFormat("pt-br", {
          currency: "BRL",
          style: "currency",
          minimumFractionDigits: 2,
        }).format(value);
      }
    },

    checkIfOrderHasChanges(orders) {
      const hasChanges = Object.keys(orders).reduce((key) =>
        ["log_permanent", "event", "log_history", "order_id"].includes(key)
      );

      if (hasChanges) {
        swal({
          title: "Ops!",
          text: this.$t("Não há nenhuma alteração no pedido."),
          type: "error",
          closeOnConfirm: false,
          closeOnCancel: false,
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: true,
        });
      }

      return hasChanges;
    },

    save(event) {
      event.target.setAttribute("disabled", true);

      if (!this.hasPermissionToEdit) {
        this.editPermissionErrorAlert();
        return;
      }

      Object.size = function (obj) {
        var size = 0,
          key;
        for (key in obj) {
          //if (obj.hasOwnProperty(key))
          size++;
        }
        return size;
      };

      let differenceBetweenObj = diff(
        this.formattedFieldsOrderClone,
        this.orderClone
      );

      if (this.checkIfOrderHasChanges(differenceBetweenObj)) {
        event.target.removeAttribute("disabled");
        return;
      }

      if (Object.size(differenceBetweenObj) === 0) {
        swal({
          title: "Ops",
          text: this.$t("Nenhuma alteração foi encontrada para ser salva!"),
          type: "info",
        });
        event.target.removeAttribute("disabled");
        return;
      }

      this.updateOrder({
        order_id: this.order.id,
        ...differenceBetweenObj,
        event: event,
      });
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    /**
     * Adiciona um novo objeto no array de shipments com dados
     * provisórios para o preenchimento dos campos.
     */
    addNewShipping() {
      this.$store.commit("ADD_NEW_SHIPMENT_ORDER", {
        shipping_company: "",
        id: Math.random().toString(36).substr(2, 5), // Gera um novo ID provisório para conseguir encontra-lo mais tarde.
      });
    },

    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();
      let form = this.$refs.formNewItem;

      let hasEmptyField = 0;
      let fields = form.querySelectorAll("input");

      fields.forEach((element) => {
        if (!element.value.length) {
          hasEmptyField++;
          element.classList.add("is-invalid");
        } else {
          element.classList.remove("is-invalid");
          element.classList.add("is-valid");
        }
      });

      if (!hasEmptyField) {
        this.submitNewItem();
      }
    },

    toggleLoadingActions() {
      let btn = this.$refs.actionButton.$el;

      if (
        btn.getAttribute("disabled") === "false" ||
        btn.getAttribute("disabled") === null
      ) {
        btn.setAttribute("disabled", true);
      } else {
        btn.setAttribute("disabled", false);
      }

      let icon = btn.querySelector(".fa");
      icon.classList.toggle("fa-gear");
      icon.classList.toggle("fa-spinner");
    },

    generatePDF(event) {
      this.toggleLoadingActions();

      let data = {
        filtered: false,
        type: "pdf",
        ids: [this.orderClone.id],
      };

      data.compactPdf = false;

      axios
        .post("/api/orders/export/selecionados", data)
        .then((success) => {
          /*let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();*/
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Exportação inserida na fila com sucesso!"),
            type: "success",
          });
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar exportar o pedido, tente novamente em alguns instantes."
            ),
            type: "error",
          });
          this.toggleLoadingActions();
        });
    },

    processing_picking() {
      this.changeStatus("picking", "processing_picking", false);
    },

    changeStatus(status, sub_status, show_modal) {
      let ids = [
        {
          id: this.order.id,
          status: status,
          sub_status: sub_status,
        },
      ];
      this.toggleLoadingActions();
      this.$http
        .post("/api/orders/updatestatus", ids)
        .then((response) => {
          let ids = response.data.join(", ");
          if (response.data.length) {
            if (show_modal == true) {
              swal(
                "Ops",
                this.$t(
                  "Não foi possivel alterar o status deste pedido, tente novamente em alguns instantes."
                ),
                "warning"
              );
            }
            this.toggleLoadingActions();
            return;
          }
          if (show_modal == true) {
            swal(
              "Pronto!",
              this.$t("O status do pedido foi alterado com sucesso!"),
              "success"
            );
          }
          if (status == "picking" && sub_status == "processing_picking") {
            //gera o PDF
            this.exportPicking();
          }
          this.toggleLoadingActions();
        })
        .catch((error) => {
          swal(
            "Ops!",
            this.$t(
              "Não foi possivel alterar o status deste pedido, tente novamente em alguns instantes."
            ),
            "warning"
          );
          this.toggleLoadingActions();
        });
    },

    exportPicking() {
      //this.toggleLoadingActions();

      let data = {
        filtered: false,
        type: "picking",
        ids: this.orderClone,
      };

      data.ids = this.orderClone;

      axios
        .post("/api/orders/export/picking", data)
        .then((success) => {
          let link = document.createElement("a");
          link.setAttribute("href", success.data.file);
          link.setAttribute("download", success.data.file);
          link.setAttribute("target", "_blank");
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          swal({
            title: this.$t("Pronto!"),
            text: this.$t("Lista de picking gerada com sucesso!"),
            type: "success",
          });
          //this.toggleLoadingActions();
          /*this.cleanActionList();
          this.loadTotalOrders();
          this.applyFilter();*/
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Não foi possivel gerar a lista de picking, tente novamente em alguns instantes."
            ),
          });
          //this.toggleLoadingActions();
        });
    },

    sigep(status, sub_status, show_modal) {
      let ids = [
        {
          id: this.order.id,
        },
      ];
      this.toggleLoadingActions();
      this.$http
        .post("/api/orders/sigep", ids)
        .then((response) => {
          let ids = response.data.join(", ");
          if (response.data.length) {
            if (show_modal == true) {
              swal(
                "Ops",
                this.$t(
                  "Não foi possivel alterar o status deste pedido, tente novamente em alguns instantes."
                ),
                "warning"
              );
            }
            this.toggleLoadingActions();
            return;
          }
          if (show_modal == true) {
            swal(
              "Pronto!",
              this.$t("O status do pedido foi alterado com sucesso!"),
              "success"
            );
          }

          this.toggleLoadingActions();
        })
        .catch((error) => {
          swal(
            "Ops!",
            this.$t(
              "Não foi possivel alterar o método de envio, tente novamente em alguns instantes."
            ),
            "warning"
          );
          this.toggleLoadingActions();
        });
    },

    submitNewItem() {
      let item = {
        order_id: this.order.id,
        item: this.newProduct,
      };

      this.addNewItem(item);
      this.$refs.modal.hide();
    },

    showLogs() {
      this.showOrderLogs(this.order.id);
    },

    expandAll() {
      let items = document.querySelectorAll(".list-group-item");

      items.forEach((item) => item.click());
    },

    clearModalNewIten() {
      this.newProduct.sku = null;
      this.newProduct.name = null;
      this.newProduct.price = null;
      this.newProduct.quantity = null;
    },

    print(tag, key, shipment, order_id) {
      var order = [order_id];
      if (tag == "has_label") {
        //chama impressão de etiqueta
        this.print_labels(order, true);
      } else {
        //outros documentos
        if (key == null || key == 0) {
          swal({
            title: "Ops!",
            text: this.$t(
              "Este pedido não possui este documento gerado pelo sistema"
            ),
          });
        } else {
          var id = [
            {
              id: order_id,
              shipments: shipment,
            },
          ];

          if (tag == "has_invoice_doc") {
            this.print_nfes(id, true);
          }

          if (tag == "has_gnre_doc") {
            this.print_gnres(id, true);
          }
        }
      }
    },

    get_print_html(tag, key) {
      var icon;
      var link;
      var name;
      var title;

      //1 - tem, 2 - foi impresso, null ou 0 - não tem
      if (key == 1) {
        title = this.$t("Disponível para impressão");
        icon = '<i class="fas fa-print" title="' + title + '"></i>';
      }

      if (key == 2) {
        title = this.$t("Impresso");
        icon = '<i class="fa fa-check text-green" title="' + title + '"></i>';
      }
      if (key == null || key == 0) {
        //etiqueta sempre vai estar habilitada para impressão
        if (tag == "has_label") {
          title = this.$t("Disponível para impressão");
          icon = '<i class="fas fa-print" title="' + title + '"></i>';
        } else {
          title = this.$t("Documento não gerado pelo sistema");
          icon =
            '<i class="fa fa-times text-danger" title="' + title + '"></i>';
        }
      }
      name = this.$t(tag);
      return icon + "&nbsp;" + name + "&nbsp;&nbsp;&nbsp;";
    },
    print_nfes(orders_ids, show_modal) {
      axios
        .post("/api/documents/get_nfes", orders_ids)
        .then((response) => {
          if (response.data.erro) {
            if (show_modal == true) {
              swal({
                title: "Ops!",
                text: response.data.erro,
                type: "error",
              });
            }
          } else {
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            if (show_modal == true) {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("Notas fiscais geradas com sucesso!"),
                type: "success",
              });
            }
          }
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar gerar as notas fiscais, tente novamente em alguns instantes."
            ),
            type: "error",
          });
        });
    },

    print_gnres(orders_ids, show_modal) {
      axios
        .post("/api/documents/get_gnres", orders_ids)
        .then((response) => {
          if (response.data.erro) {
            if (show_modal == true) {
              swal({
                title: "Ops!",
                text: this.$t(
                  "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
                ),
                type: "error",
              });
            }
          } else {
            let link = document.createElement("a");
            link.setAttribute("href", response.data.file);
            link.setAttribute("download", response.data.file);
            link.setAttribute("target", "_blank");
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            if (show_modal == true) {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("GNREs geradas com sucesso!"),
                type: "success",
              });
            }
          }
        })
        .catch((error) => {
          swal({
            title: "Ops!",
            text: this.$t(
              "Ocorreu algum problema ao tentar gerar as GNREs, tente novamente em alguns instantes."
            ),
            type: "error",
          });
        });
    },

    print_labels(orders_ids, show_modal) {
      axios
        .post("/api/documents/get_labels", orders_ids)
        .then((response) => {
          if (response.data.urls) {
            response.data.urls.forEach(function (pdf_link) {
              if (pdf_link != null) {
                var type = pdf_link.substr(pdf_link.length - 3);
                let link = document.createElement("a");
                link.setAttribute("href", pdf_link);
                link.setAttribute("target", "_blank");
                if (type == "zpl") {
                  link.setAttribute("download", "etiqueta.zpl");
                  link.href = window.URL.createObjectURL(
                    new Blob([pdf_link], { type })
                  );
                } else {
                  link.setAttribute("download", pdf_link);
                }

                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
              }
            });
            if (show_modal == true) {
              swal({
                title: this.$t("Pronto!"),
                text: this.$t("Etiquetas geradas com sucesso!"),
                type: "success",
              });
            }
          } else {
            if (show_modal == true) {
              if (response.data.error) {

                if (response.data.error.orders) {
                  var text = this.$t(
                    "Ocorreu algum problema ao tentar gerar as etiquetas do(s) pedido(s)"
                  );

                  for (var key in response.data.error.orders) {
                    text = text + "<br><br>" + this.$t("Pedido") + " " + key;
                    for (var key2 in response.data.error.orders[key]) {
                      text =
                        text + "<br>" + response.data.error.orders[key][key2];
                    }
                  }
                }

                if (response.data.error.config) {

                  var text = this.$t(
                    "Ocorreu algum problema ao tentar gerar as etiquetas"
                  );

                  text =
                    text +
                    "<br><br>" +
                    this.$t("Clique") +
                    ' <a href="http://beta.plugg.to/settings#labels" target="_parent">' +
                    this.$t("aqui") +
                    " <a> " +
                    this.$t("para configurar o formato de impressão") +
                    ".";
                }

                swal({
                  title: "Ops!",
                  html: text,
                  type: "error",
                });
              } else {
                swal({
                  title: this.$t("Pronto!"),
                  text: this.$t("Etiquetas geradas com sucesso!"),
                  type: "success",
                });
              }
            }
          }
        })
        .catch((error) => {

          let message =
            "Ocorreu algum problema ao tentar gerar as etiquetas do pedido, tente novamente em alguns instantes";
          if (error.response && error.response.data) {
            message = JSON.parse(error.response.data);
          }
          swal({
            title: "Ops!",
            text: this.$t(message),
            type: "error",
          });
        });
    },

    print_all(order) {
      var id = [
        {
          id: order.id,
          shipments: order.shipments,
        },
      ];
      this.print_labels([order.id], false);
      this.print_nfes(id, false);
      this.print_gnres(id, false);
      swal({
        title: this.$t("Pronto!"),
        text: this.$t("Todos os documentos disponíveis impressos com suceso!"),
        type: "success",
      });
    },
  },
};
</script>

<style scoped>
.log-item {
  margin: 0.5rem 0 !important;
}

.input-group label {
  width: 1000%;
}

.input-group {
  margin-bottom: 15px;
}

.show-order-header {
  margin-top: 15px;
}

.log_history .date,
.log_permanent .date {
  font-size: 0.8rem;
  display: block;
  font-weight: bold;
}
.log_history .message,
.log_permanent .message {
  font-size: 1rem;
  display: block;
}
.log_history .app,
.log_permanent .app {
  font-size: 0.8rem;
  display: block;
}
.teste {
  display: none;
}

.list-group .list-group-item {
  border-radius: 0;
}

.list-group:first-of-type .list-group-item {
  border-radius: 3px 3px 0 0;
}

.list-group:last-of-type .list-group-item {
  border-radius: 0 0 3px 3px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders/ShowOrder.vue